module.exports = __webpack_public_path__ + "652606653bc50a089996b2c7772039a9.svg";